import {
  Box,
  Grid,
  ListItem,
  ListItemIcon,
  Typography,
  useTheme,
} from "@mui/material";
import { heroContent } from "../../data/heroContent";
import { iconsMap } from "../utils/iconsMap";
import SectionYellowTitle from "../common/SectionYellowTitle";
import SectionMainTitle from "../common/SectionMainTitle";
import useResponsiveSpacingGrid from "../../hooks/useResponsiveSpacingGrid";

const HowWeHelpSection: React.FC = () => {
  const theme = useTheme();
  const spacing = useResponsiveSpacingGrid();

  return (
    <Box
      sx={{
        pb: { xs: 6, md: 8 },
        px: { xs: 2, sm: 4, md: 6 },
        maxWidth: "1250px",
        mx: "auto",
        mt: { md: 6 },
      }}
    >
      {/* Sección amarillo pequeño */}
      <SectionYellowTitle
        title={heroContent.howWeHelp.subtitle}
        marginBottom={1}
      />

      <Grid
        container
        spacing={spacing}
        justifyContent="space-between"
        sx={{
          alignItems: "center",
          textAlign: { xs: "left", md: "left" },
        }}
      >
        <SectionMainTitle title={heroContent.howWeHelp.title} />
        {/* Texto */}
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            textAlign: "justify",
          }}
        >
          {heroContent.howWeHelp.paragraph}
        </Typography>

        {/* Key points abajo */}

        {heroContent.howWeHelp.keyBenefits.map((benefit, index) => {
          const IconComponent =
            iconsMap[benefit.icon] || iconsMap["CheckCircleIcon"];
          return (
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
              key={benefit.label}
            >
              <ListItem
                key={index}
                sx={{
                  py: 2,
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: 1,
                  border: `1px solid ${theme.palette.text.disabled}`,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 40,
                    color: theme.palette.primary.main,
                  }}
                >
                  <IconComponent />
                </ListItemIcon>
                <Box sx={{ flexDirection: "row" }}>
                  <Typography variant="h6" color={theme.palette.secondary.main}>
                    {benefit.label}
                  </Typography>

                  <Typography variant="body2">{benefit.value}</Typography>
                </Box>
              </ListItem>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default HowWeHelpSection;
